import { selectSalesIntelligenceState } from "app/pages/sales-intelligence/store/selectors";
import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";
import type { RootState } from "single-spa/store/types";

import type { AdvancedSearchFilteringState, FiltersPanelState } from "./types";

const select = createStatePropertySelector<AdvancedSearchFilteringState>(
    selectSalesIntelligenceState("advancedSearchFiltering"),
);

const selectFiltersPanelState = createStatePropertySelector<FiltersPanelState>((state: RootState) =>
    select("filtersPanel")(state),
);

export const selectIsNewOnlyEnabled = select("isNewOnly");

export const selectSelectedFilterCategory = selectFiltersPanelState("selectedFilterCategory");
export const selectIsFiltersCategoriesPanelExpanded = selectFiltersPanelState("isFiltersCategoriesPanelExpanded");
export const selectIsFiltersPanelExpanded = selectFiltersPanelState("isFiltersPanelExpanded");
export const selectExpandedFilter = selectFiltersPanelState("expandedFilter");
export const selectFilterMode = selectFiltersPanelState("filterMode");
export const selectSearchQuery = selectFiltersPanelState("searchQuery");
export const selectIsInitialFiltersReady = selectFiltersPanelState("isInitialFiltersReady");
